const Store = {
  saveValue(key, value) {
    localStorage.setItem(key, value);
  },
  getValue(key) {
    return localStorage.getItem(key);
  },
  removeValue(key) {
    localStorage.removeItem(key);
  },
  token() {
    return this.getInfo('token');
  }
}

export default Store;